/**
 * The four measurements every calculation on the boat's side needs, in centimetres.
 * Kept in one place because two screens ask for them: Settings, and the guided setup
 * that runs once when the app is first used in earnest.
 */
import type { MessageKey } from '../i18n'

export interface Measure {
  key: 'draught' | 'keelClearance' | 'mastHeight' | 'mastClearance' | 'surge'
  label: MessageKey
  help: MessageKey
  /** The two step sizes: a rig is tens of decimetres from its default, a keel is not */
  coarse: number
  fine: number
  min: number
  max: number
}

export const MEASURES: readonly Measure[] = [
  { key: 'draught', label: 'draughtSetting', help: 'draughtHelp', coarse: 10, fine: 1, min: 10, max: 1000 },
  { key: 'keelClearance', label: 'keelClearance', help: 'keelClearanceHelp', coarse: 10, fine: 1, min: 0, max: 1000 },
  { key: 'mastHeight', label: 'mastHeightSetting', help: 'mastHeightHelp', coarse: 100, fine: 10, min: 10, max: 5000 },
  { key: 'mastClearance', label: 'mastClearance', help: 'mastClearanceHelp', coarse: 10, fine: 1, min: 0, max: 1000 },
]

/**
 * Not a measurement of the boat but of the day: what the wind is doing to the water that
 * the prediction cannot know. Same editor, its own place on the screen, and the same
 * range the old app allowed — three metres either way, in decimetres.
 */
export const SURGE: Measure = {
  key: 'surge', label: 'surgeSetting', help: 'surgeHelp', coarse: 10, fine: 1, min: -300, max: 300
}
